import { styled } from 'styled-components';

const StyledLogo = styled('img')`
  width: 92px;
  height: auto;

  @media (min-width: 426px) {
    width: 132px;
  }

  @media (min-width: 1441px) {
    width: 172px;
  }
`;

export default StyledLogo;
